import { render } from "./RegisterComp.vue?vue&type=template&id=7bf83302"
import script from "./RegisterComp.vue?vue&type=script&lang=js"
export * from "./RegisterComp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__